import _Upload from './Upload';
import './style';

export type { UploadProps } from './Upload';
export * from './type';

export const Upload = _Upload;
export default Upload;
